"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferNotificationSubscriptionPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const index_1 = require("@src/app/index");
const offer_notification_subscription_form_1 = require("@src/components/modules/forms/offer-notification-subscription-form");
const elements_1 = require("@src/components/elements");
const loading_wrapper_1 = __importDefault(require("@src/components/modules/global/loading-wrapper"));
const button_1 = __importDefault(require("@src/components/modules/global/button"));
const Api = __importStar(require("@src/api"));
const OfferNotificationSubscriptionPage = () => {
    const [subscription, setSubscription] = react_1.default.useState(null);
    const [subscriptionWasJustDeleted, setSubscriptionWasJustDeleted] = react_1.default.useState(false);
    const [isLoading, setIsLoading] = react_1.default.useState(true);
    const intl = (0, react_intl_1.useIntl)();
    const showErrorNotification = () => {
        antd_1.notification.error({
            message: intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.error',
                defaultMessage: 'Chyba',
            }),
            description: intl.formatMessage({
                id: 'forms.offer_notification_subscription_form.something_went_wrong',
                defaultMessage: 'Niekde nastala chyba.',
            }),
        });
    };
    const initialize = async () => {
        var _a;
        setIsLoading(true);
        try {
            const token = index_1.history.getQuery().onst;
            const fetchedSubscription = await Api.OfferNotificationSubscription.getSubscription(token);
            setSubscription(fetchedSubscription);
        }
        catch (err) {
            if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
                showErrorNotification();
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    react_1.default.useEffect(() => {
        initialize();
    }, []);
    const handleDelete = () => {
        setSubscription(null);
        setSubscriptionWasJustDeleted(true);
    };
    return ((0, jsx_runtime_1.jsx)(loading_wrapper_1.default, { isLoading: isLoading, children: subscription ? ((0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, children: (0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)("h1", { className: "headline headline--1 headline--line-behind", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_notification_subscription.new_subscription", defaultMessage: "Odoberanie nov\u00FDch pon\u00FAk" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsx)(offer_notification_subscription_form_1.OfferNotificationSubscriptionForm, { subscription: subscription, showEmailField: true, onSubmit: initialize, onDelete: handleDelete }) }) })] }) })) : ((0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, children: (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], children: (0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, className: "text-center", children: [(0, jsx_runtime_1.jsx)("h1", { className: "headline headline--1 headline--line-behind", children: subscriptionWasJustDeleted
                                ? intl.formatMessage({
                                    id: 'offer_notification_subscription.subscription_successfully_deleted',
                                    defaultMessage: 'Odoberanie úspešne zmazané',
                                })
                                : intl.formatMessage({
                                    id: 'offer_notification_subscription.subscription_not_found',
                                    defaultMessage: 'Odoberanie nebolo nájdené',
                                }) }), (0, jsx_runtime_1.jsx)("div", { className: "page-not-found__content", children: (0, jsx_runtime_1.jsx)("p", { children: subscriptionWasJustDeleted
                                    ? intl.formatMessage({
                                        id: 'offer_notification_subscription.subscription_deletion_was_successful',
                                        defaultMessage: 'Vymazanie odberu prebehlo úspešne',
                                    })
                                    : intl.formatMessage({
                                        id: 'offer_notification_subscription.we_are_sorry_but',
                                        defaultMessage: 'Ľutujeme, ale hľadaný odber nebol nájdený',
                                    }) }) }), (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/", children: (0, jsx_runtime_1.jsx)(button_1.default, { color: "brand", text: intl.formatMessage({
                                    id: 'offer_notification_subscription.continue_to_home_page',
                                    defaultMessage: 'Pokračovať na hlavnú stránku',
                                }) }) })] }) }) })) }));
};
exports.OfferNotificationSubscriptionPage = OfferNotificationSubscriptionPage;
